export function formatDate(dateStr: string): string {
  try {
    const date = new Date(dateStr);

    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
}